export function useMask() {
    // We use '*' for all positions to allow both letters and numbers
    // The first two are usually letters (Country Code), followed by check digits,
    // and then the BBAN which can be alphanumeric.
    const ibanMask = '**## **** **** **** **** **** **** ****'

    const everyFourSpace = (text: string) => {
        if (!text) {
            return
        }
        return text
            .replace(/[^a-zA-Z0-9]/g, '') // Remove everything except alphanumeric
            .toUpperCase() // IBANs are standardly uppercase
            .replace(/(.{4})(?=.)/g, '$1 ') // Group by 4 with a trailing lookahead to avoid space at the end
            .trim()
    }

    return {
        ibanMask,
        everyFourSpace,
    }
}
